var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccessLevelIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 144,
    height: 144,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(2 2)",
    stroke: "#D2D2D9",
    strokeWidth: 2.75,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#EEF0F3",
    width: 79.13,
    height: 18.261,
    rx: 6.087
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#FFF",
    x: 60.87,
    y: 73.043,
    width: 79.13,
    height: 18.261,
    rx: 6.087
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#EEF0F3",
    x: 60.87,
    y: 121.739,
    width: 79.13,
    height: 18.261,
    rx: 6.087
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.478 91.304v30.435M42.609 18.267v27.391a9.13 9.13 0 0 0 9.13 9.13h42.609a9.13 9.13 0 0 1 9.13 9.131v9.13"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccessLevelIcon);
export default __webpack_public_path__ + "static/media/access-level-icon.a03d6e9d663cd41b8e1847f08903f8fb.svg";
export { ForwardRef as ReactComponent };